import { render, staticRenderFns } from "./ImportCallSounds.vue?vue&type=template&id=4229eb3e&"
import script from "./ImportCallSounds.vue?vue&type=script&lang=ts&"
export * from "./ImportCallSounds.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports